import Headroom from "headroom.js";

(function ($) {
	var offset_for_section_after_filter = $(
		".sectionParalax--diff, .section-parallax__container"
	).offset();
	if (!offset_for_section_after_filter) {
		return;
	}

	var options = {
		offset: Math.round(offset_for_section_after_filter.top) - 150,
		tolerance: {
			up: 5,
			down: 100,
		},
	};

	const hot_link_container = document.querySelector(".hotLink");

	if (!hot_link_container) {
		return;
	}

	var headroom = new Headroom(hot_link_container, options);
	headroom.init();

	var hot_link_close = $(".hotLink__close");

	hot_link_close.on("click", function () {
		hot_link_container.addClass("hidden");
	});
	const optionsHeader = {
		tolerance: {
			up: 5,
			down: 100,
		},
	};
	const headerContainer = document.querySelector(".tip-top-bars");
	let headRoomHeader = new Headroom(headerContainer, optionsHeader);
	//headRoomHeader.init();
	/* ==========================================
	scrollTop() >= 300
	Should be equal the the height of the header
	========================================== */
	$(window).scroll(function () {
		if ($(window).scrollTop() >= 180) {
			$(".tip-top-bar-desktop").addClass("fixed-header");
			$(".tip-top-bar-mobile").addClass("fixed-header");
		} else {
			$(".tip-top-bar-desktop").removeClass("fixed-header");
			$(".tip-top-bar-mobile").removeClass("fixed-header");
		}
	});
})(jQuery);
